/**
 * useMultimoneda — indica si el condominio activo tiene multimoneda habilitada.
 *
 * Lee el flag `multimoneda_activa` de localStorage y se suscribe a cambios
 * via el evento "storage" (cross-tab) y un evento custom "multimoneda-changed"
 * (mismo tab, p.ej. cuando el CONTADOR cambia de condominio o el admin lo activa
 * desde SettingsPage).
 *
 * Devuelve:
 *   true  → mostrar campos USD, TC, equivalencias
 *   false → modo CRC clásico
 */
import { useState, useEffect } from "react";

function readFlag() {
  return localStorage.getItem("multimoneda_activa") === "true";
}

export function useMultimoneda() {
  const [value, setValue] = useState(readFlag);

  useEffect(() => {
    function sync() { setValue(readFlag()); }

    // Cambios desde OTRA pestaña del mismo navegador
    window.addEventListener("storage", sync);
    // Cambios desde la MISMA pestaña (disparado manualmente tras escribir en localStorage)
    window.addEventListener("multimoneda-changed", sync);

    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("multimoneda-changed", sync);
    };
  }, []);

  return value;
}

/**
 * Escribe el flag en localStorage y notifica a todos los componentes que usan
 * useMultimoneda() en la misma pestaña.
 * Usalo en lugar de localStorage.setItem("multimoneda_activa", ...) directo.
 */
export function setMultimonedaFlag(active) {
  localStorage.setItem("multimoneda_activa", active ? "true" : "false");
  window.dispatchEvent(new Event("multimoneda-changed"));
}
